<template>
  <table class="fitstTable" border="1">
    <thead>
      <tr>
        <th>班次名称</th>
        <th>授课时间</th>
        <th>课程名称</th>
        <th>授课教师</th>
        <th>授课地点</th>
        <th>查看课表</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item, index) in list">
        <template v-for="(innerItem, innerindex) in item.curCourse">
          <tr :key="index + '-' + innerindex">
            <td
              v-if="!innerindex"
              class="className"
              :rowspan="item.curCourse.length"
            >
              {{ item.className }}
            </td>
            <td class="teachingTime">{{ innerItem.courseDate }} {{ innerItem.beginTime }}</td>
            <td class="projectName">{{ innerItem.courseName }}</td>
            <td class="teachingTeachers">
              {{ innerItem.teacher }}
            </td>
            <td class="teachingAddress">
              {{ innerItem.place }}
            </td>
            <td
              v-if="!innerindex"
              :rowspan="item.curCourse.length"
              class="weekschedule"
            >
              <div class="schedule" @click="clickschedule(item)">一周课表</div>
            </td>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</template>
<script>
export default {
  data() {
    return {
     
    };
  },
  created() {
    
  },
  props: {
    list: {
        type: Array,
        default: () => ([]),
    }
  },
  methods: {
   
    clickschedule(item) {
        this.$emit('openSchedule',item);
    },
    
  },
};
</script>
